import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { authenticatedHeadersHash } from "views_shared/app/javascript/scripts/authentication";
import ImageCropped from "views_shared/app/javascript/components/ImageCropped";

function RequestResult({ gid, setResultTitle, setResultUrl }) {
  const match = gid.match(/gid:\/\/qwoted\/([^/]+)\/(\d+)/);
  const requestId = match ? match[2] : null;
  const [request, setRequest] = useState(null);

  useEffect(() => {
    const query = `${globalThis.Qwoted.SUPABASE_API_EXTERNAL_URL}/rest/v1/requests?id=eq.${requestId}`;
    fetch(query, {
      method: "GET",
      headers: new Headers(authenticatedHeadersHash()),
    })
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson[0]) {
          const r = responseJson[0];
          setRequest(r);
          setResultTitle(r.title);
          setResultUrl(`/requests/${r.slug}`);
        }
      });
  }, [requestId, setResultTitle, setResultUrl]);

  if (!request) {
    return null;
  }

  return (
    <div className="d-flex">
      <ImageCropped
        wrapperClasses="me-2"
        src={request.media_outlet_profile_image_url}
        alt={`${request.media_outlet_name} logo`}
        size={45}
      />
      <div className="d-flex flex-column">
        <a href={`/media_outlets/${request.media_outlet_slug}`}>{request.media_outlet_name}</a>
        {globalThis.Qwoted.V1_URL && request.migrate_id && (
          <a href={`${globalThis.Qwoted.V1_URL}/source_requests/${request.migrate_id}`}>V1 Link</a>
        )}
      </div>
    </div>
  );
}

RequestResult.propTypes = {
  gid: PropTypes.string.isRequired,
};
export default RequestResult;
